import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const LinkedinIconInvoice = ({
  color = colors.black,
  className,
  onClick,
  style,
  size = 20,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={'0 0 16 16'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={style}
    >
      <path
        d="M8.60059 11.4032C8.60059 11.0718 8.86882 10.8036 9.2002 10.8036C9.53157 10.8036 9.7998 11.0718 9.7998 11.4032C9.7998 12.6874 10.8417 13.7284 12.126 13.7284C13.4101 13.7283 14.4512 12.6874 14.4512 11.4032C14.4512 11.0718 14.7204 10.8036 15.0518 10.8036C15.3829 10.8038 15.6514 11.072 15.6514 11.4032C15.6514 13.3501 14.0728 14.9285 12.126 14.9286C10.179 14.9286 8.60059 13.3502 8.60059 11.4032Z"
        fill={color}
      />
      <path
        d="M12.5596 9.23224C12.5594 8.9938 12.3654 8.79962 12.127 8.79962C11.8886 8.7998 11.6945 8.9939 11.6943 9.23224V11.4285C11.6943 11.667 11.8885 11.861 12.127 11.8611C12.3656 11.8611 12.5596 11.6671 12.5596 11.4285V9.23224ZM13.7598 11.4285C13.7598 12.3299 13.0283 13.0613 12.127 13.0613C11.2258 13.0612 10.4951 12.3298 10.4951 11.4285V9.23224C10.4953 8.33116 11.2259 7.60058 12.127 7.6004C13.0282 7.6004 13.7596 8.33105 13.7598 9.23224V11.4285Z"
        fill={color}
      />
      <path
        d="M11.5273 15.3151V14.4548C11.5273 14.1235 11.7958 13.8554 12.127 13.8552C12.4583 13.8552 12.7275 14.1234 12.7275 14.4548V15.3151C12.7275 15.6465 12.4583 15.9157 12.127 15.9157C11.7958 15.9155 11.5273 15.6464 11.5273 15.3151Z"
        fill={color}
      />
      <path
        d="M4 16H9.33333C9.70152 16 10 15.7015 10 15.3333C10 14.9651 9.70152 14.6667 9.33333 14.6667H4C2.5296 14.6667 1.33333 13.4704 1.33333 12V4C1.33333 2.5296 2.5296 1.33333 4 1.33333H12C13.4704 1.33333 14.6667 2.5296 14.6667 4V10C15.5 10 16 10.4488 16 10.4488V4C16 1.7944 14.2056 0 12 0H4C1.7944 0 0 1.7944 0 4V12C0 14.2056 1.7944 16 4 16Z"
        fill={color}
      />
      <path
        d="M5.33333 11.3333V6.6064C5.33333 6.23827 5.0348 5.93974 4.66667 5.93974C4.29853 5.93974 4 6.23827 4 6.6064V11.3333C4 11.7015 4.29853 12 4.66667 12C5.0348 12 5.33333 11.7015 5.33333 11.3333Z"
        fill={color}
      />
      <path
        d="M4 4.4C4 4.03187 4.29853 3.73334 4.66667 3.73334C5.0348 3.73334 5.33333 4.03187 5.33333 4.4V4.53334C5.33333 4.90147 5.0348 5.2 4.66667 5.2C4.29853 5.2 4 4.90147 4 4.53334V4.4Z"
        fill={color}
      />
      <path
        d="M7.9968 6.63627C8.71347 6.07214 9.53613 5.89814 10.2025 6.02907C10.6608 6.11912 11.0511 6.34066 11.3497 6.66153C11.3875 6.7022 11.3822 6.7656 11.3396 6.80122C11.1622 6.94944 10.7238 7.31673 10.5136 7.50308C10.451 7.55855 10.3644 7.55271 10.2995 7.5C10.1998 7.41905 10.0812 7.36386 9.94547 7.3372C9.3368 7.2176 8.4816 7.682 8.02413 8.80094C8.01747 8.8172 8.00773 8.83094 8 8.84627V10.5C7.5 11 7.5 11.5 7.33333 12C6.9652 12 6.66667 11.7015 6.66667 11.3333V6.66774C6.66667 6.2996 6.9652 6.00107 7.33333 6.00107C7.69067 6.00107 7.98 6.28307 7.9968 6.63627Z"
        fill={color}
      />
    </svg>
  );
};

export default LinkedinIconInvoice;
